import { Injectable } from '@angular/core';
import { HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { ConfigService } from '../services/config.service';
import { BrowserFingerprintService } from '../services/browser-fingerprint.service';
import { isLocalhostTokenServiceUrl } from '../utils/localhost-token-service.utils';

/**
 * Builds API requests the backend expects for cookie sessions:
 * credentials, device fingerprint, language, and optional screen id.
 */
@Injectable({ providedIn: 'root' })
export class ApiRequestHeadersService {
  constructor(
    private configService: ConfigService,
    private fingerprintService: BrowserFingerprintService,
    private router: Router,
  ) {}

  enrich(request: HttpRequest<unknown>): HttpRequest<unknown> {
    const cfg = this.configService.configIfReady;
    const baseUrl = cfg?.BASE_URL ?? '';
    const isApiRequest = !!baseUrl && request.url.startsWith(baseUrl);
    const isLocalTokenRequest = isLocalhostTokenServiceUrl(request.url);

    let headers = request.headers;

    if (isApiRequest) {
      const fp = this.fingerprintService.getCached();
      if (fp) {
        headers = headers.set('X-Device-Fingerprint', fp);
      }
      headers = headers.set('Accept-Language', localStorage.getItem('language') || 'en');

      const screenId = localStorage.getItem('screenId');
      const removeScreenId = localStorage.getItem('removeScreenId') === 'true';

      if (this.router.url.includes('/digital-signature?')) {
        if (screenId) {
          headers = headers.set('screen_id', screenId);
        }
      } else {
        if (!headers.has('Content-Type') && request.body && !(request.body instanceof FormData)) {
          headers = headers.set('Content-Type', 'application/json');
        }
        if (!removeScreenId && screenId) {
          headers = headers.set('screen_id', screenId);
        }
      }
    } else if (isLocalTokenRequest) {
      // Local USB/token agent needs locale for errorDescription / errorMsg.
      headers = headers.set('Accept-Language', localStorage.getItem('language') || 'en');
    }

    // Flag is one-shot: doc-mgmt and refresh flows set it when screen_id must be omitted once.
    localStorage.removeItem('removeScreenId');

    const useCredentials =
      isApiRequest && !isLocalTokenRequest;

    return request.clone({
      headers,
      withCredentials: useCredentials,
    });
  }
}
